import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as artifactActions from '~/artifact/actions';
import classNames from 'classnames';
import { vulnerabilityRangeTypesMap } from '~/constants/ModelConstants';
type ArtifactViewSelectProps = {
  actions: object;
  rangeType?: string;
  artifactState: object;
  componentId?: number;
  listData: any[];
};
type ArtifactViewSelectState = {
  isFocused: boolean;
};
class ArtifactViewSelect extends React.Component<ArtifactViewSelectProps, ArtifactViewSelectState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isFocused: false,
    };
  }
  componentDidMount() {
    let listData = this.props.listData,
      defaultRange = listData && listData[0] ? listData[0].range : {},
      componentId = this.props.componentId,
      vulnerableRangeByComponent = this.props.artifactState.vulnerableRangeByComponent || {};
    if (!vulnerableRangeByComponent[componentId] && !_.isEmpty(defaultRange)) {
      this.props.actions.updateVulnerableRangeByComponent(defaultRange, componentId);
    }
  }
  UNSAFE_componentWillUpdate(nextProps) {
    let newStore = nextProps.artifactState,
      componentId = nextProps.componentId,
      listData = nextProps.listData,
      defaultRange = listData && listData[0] ? listData[0].range : {};
    if (!newStore.vulnerableRangeByComponent[componentId] && !_.isEmpty(defaultRange)) {
      this.props.actions.updateVulnerableRangeByComponent(defaultRange, componentId);
    }
  }
  toggleFocused = () => {
    let isFocused = this.state.isFocused,
      listData = this.props.listData;
    if (listData.length > 1) {
      this.setState({ isFocused: !isFocused }); // eslint-disable-line
      this.props.actions.updateRangeSelectFocus(!isFocused);
    }
  };
  triggerUnfocused = () => {
    this.setState({ isFocused: false }); // eslint-disable-line
    this.props.actions.updateRangeSelectFocus(false);
  };
  handleSelect = versionRange => {
    const { componentId } = this.props;
    const range = versionRange;
    this.props.actions.fetchSafeVersionsAfterRange(componentId, range.versionRange);
    // actually reflect the new choice in the UI
    this.props.actions.updateVulnerableRangeByComponent(versionRange, componentId);
    this.triggerUnfocused();
  };
  render() {
    let listData = this.props.listData || [],
      defaultRange = listData && listData[0] ? listData[0] : {},
      list = [],
      store = this.props.artifactState,
      rangeType = this.props.rangeType || vulnerabilityRangeTypesMap.VERSIONS,
      componentId = this.props.componentId,
      activeRanges = store.vulnerableRangeByComponent || {},
      activeRange = activeRanges[componentId] || defaultRange || {},
      isFocused = this.state.isFocused,
      currentRangeClasses = classNames({
        'bo-rad--0 bo--1 border-color--primary p- font--14 color--primary position--relative flex flex--justify-content--space-between': true,
        'cursor--pointer': listData.length > 1,
        'cursor--not-allowed': listData.length <= 1,
      }),
      listClasses = classNames({
        'list--group': true,
        'overflow-y--scroll': true,
        'right--0': true,
        'col-1-1': true,
        'font--14': true,
        'top--40': rangeType === vulnerabilityRangeTypesMap.VERSIONS,
        'top--51': rangeType === vulnerabilityRangeTypesMap.COMMIT_HASHES,
        'position--absolute': true,
        'zIndex-9--overlay': true,
        'cursor--pointer': true,
        'max-height--50vh': true,
        hidden: !isFocused,
      }),
      iconClasses = classNames({
        sci: true,
        'sci__caret--up': isFocused,
        'sci__caret--down': !isFocused,
        hidden: listData.length <= 1,
      });
    listData.forEach((item, index) => {
      if (rangeType === 'ALL') {
        //This displays a simple dropdown for vX.Y.Z and HEAD (<7 char commit hash for start and end ie. xxxxxxx-yyyyyyy)
        if (item.versionRange !== 'HEAD') {
          list.push(
            <li
              key={index}
              className="list--group__item border-color--primary-light p-"
              onClick={() => this.handleSelect(item)}
            >
              {item.versionRange}
            </li>
          );
        } else {
          list.push(
            <li
              key={index}
              className="list--group__item border-color--primary-light p-"
              onClick={() => this.handleSelect(item)}
            >
              <div className="col-9-10 text--ellipsis max-width--500">
                {listData.length > 0 ? (
                  <div>
                    HEAD ({item.startCommit && item.startCommit.slice(0, 7)} &mdash;{' '}
                    {item.endCommit && item.endCommit.slice(0, 7)})
                  </div>
                ) : (
                  'No vulnerable commit hashes'
                )}
              </div>
            </li>
          );
        }
      } else if (rangeType === vulnerabilityRangeTypesMap.VERSIONS) {
        //This displays just the versions
        list.push(
          <li
            key={index}
            className="list--group__item border-color--primary-light p-"
            onClick={() => this.handleSelect(item)}
          >
            {item.versionRange}
          </li>
        );
      } else if (rangeType === vulnerabilityRangeTypesMap.COMMIT_HASHES) {
        //This displays full commit hashes START: <full commit hash> and END: <full commit hash>
        list.push(
          <li
            key={index}
            className="list--group__item border-color--primary-light p-"
            onClick={() => this.handleSelect(item)}
          >
            <div className="col-9-10 text--ellipsis max-width--500">
              <div>
                <span className="text--bold font--11 inline-block col-1-10">START</span>{' '}
                {item.startCommit}
              </div>{' '}
              <div>
                <span className="text--bold font--11 inline-block col-1-10">END</span>{' '}
                {item.endCommit}
              </div>
            </div>
          </li>
        );
      }
    });
    let listDataDisplay = null;
    if (rangeType === 'ALL') {
      if (activeRange.versionRange !== 'HEAD') {
        listDataDisplay = (
          <span className="col-9-10 text--ellipsis max-width--500">
            {listData.length > 0 ? activeRange.versionRange : 'No vulnerable versions'}
          </span>
        );
      } else {
        listDataDisplay = (
          <div className="col-9-10 text--ellipsis max-width--500">
            {listData.length > 0 ? (
              <div>
                HEAD ({activeRange.startCommit && activeRange.startCommit.slice(0, 7)} &mdash;{' '}
                {activeRange.endCommit && activeRange.endCommit.slice(0, 7)})
              </div>
            ) : (
              'No vulnerable commit hashes'
            )}
          </div>
        );
      }
    } else if (rangeType === vulnerabilityRangeTypesMap.VERSIONS) {
      listDataDisplay = (
        <span className="col-9-10 text--ellipsis max-width--500">
          {listData.length > 0 ? activeRange.versionRange : 'No vulnerable versions'}
        </span>
      );
    } else if (rangeType === vulnerabilityRangeTypesMap.COMMIT_HASHES) {
      listDataDisplay = (
        <div className="col-9-10 text--ellipsis max-width--500">
          {listData.length > 0 ? (
            <div>
              <div>
                <span className="text--bold font--11 inline-block col-1-10">START</span>{' '}
                {activeRange.startCommit}
              </div>{' '}
              <div>
                <span className="text--bold font--11 inline-block col-1-10">END</span>{' '}
                {activeRange.endCommit}
              </div>
            </div>
          ) : (
            'No vulnerable commit hashes'
          )}
        </div>
      );
    }
    return (
      <div className="grid grid--full">
        <div className="grid__item col-1-1 position--relative">
          <div className={currentRangeClasses} onClick={this.toggleFocused}>
            {listDataDisplay}
            <i className={iconClasses} />
          </div>
          <ul className={listClasses} style={{ maxHeight: 'auto' }}>
            {list}
          </ul>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewSelect);
